import { TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "default !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function JobGroupsTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();

  return (
    <>
      <TableRow
        hover
        className={classes.rowCell}
        key={index}
        component={Link}
        to={{ pathname: "/jobgroups/jobgroupdetailed", state: element }}
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {element[column.propName]}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
